import React, { PureComponent } from 'react'
import { Panel } from 'react-bootstrap'
import { stringLength } from '../../../../constants/management/fleets'
import { dossierTypes as dossierTypesConstant } from '../../../../constants/dossier/common/dossierTypes'
import { dossierSubTypeId } from '../../../../constants/dossier/common/dossierSubType'
import Client from '../../../../components/dossiers/common/Client'
import ChargeFleetListComponentPage from '../../../../containers/management/fleets/data/ChargeFleetListComponentPage'

class DataClientChargeComponent extends PureComponent {
  constructor (props) {
    super()
    this.state = {
      openPanelClient: false
    }
  }

  collapsePanelClient () {
    this.setState({ openPanelClient: !this.state.openPanelClient })
  }

  componentDidUpdate (prevProps) {
    if (this.props.fleetId === '-1' && this.props.formValues?.organizedUnitId && !this.state.openPanelClient) {
      this.setState({ openPanelClient: true })
    }
  }

  foreignPassportWarning (values) {
    // Temporary solution to avoid client error caused by parallel history that cannot be integrated here yet
  }

  updateComponentAfterDeleteAndRestart () { }

  render () {
    const {
      t, change, combos, readOnlyFields, formValues, dispatch, stopAsyncValidation, asyncValidateFunc, tKey,
      clientFleetPermissions, entityComponent, entityChildComponent, disableDeleteButton, tabActiveKey, fleetData, fleetId, haveChanges,
      actions: {
        fetchClientByDni,
        fetchClientByDniEntityChild,
        fetchClientFromDocument,
        setEntityTypeId,
        setEntitySubTypeId,
        setEntityId,
        fetchEntitySubTypeCombo,
        fetchEntityFilterSubTypeCombo,
        setEntityChildTypeId,
        clearEntity,
        clearEntityChild,
        fetchSalesClient,
        setEntityValidationDisable,
        setActiveSection,
        fetchCommercialSocietyTypeCombo,
        fetchEntityCountryTypeCombo,
        fetchEntityStateTypeCombo,
        fetchEntityCityTypeCombo,
        fetchEntityTownTypeCombo,
        fetchEntityColonyTypeCombo,
        fetchEntityCPTypeCombo,
        fetchEntityMaritalStatusCombo,
        openModal,
        fetchActivityBpro,
        validate,
        resetValues,
        fetchClientDataAddress,
        clearClientFields
      }
    } = this.props

    let dossier = {
      isPreCancelled: false,
      entityComponent: entityComponent,
      dossierParentId: null,
      parentEntityId: null,
      entityChildComponent: entityChildComponent,
      entityTypeIdDefault: null,
      salesComponent: null,
      entityFromParentDossier: null,
      dossierSubTypeId: dossierSubTypeId.venta_vn,
      organizedUnitId: this.props.fleetData?.fleet?.organizedUnitId || this.props.formValues?.organizedUnitId,
      dossierId: -1
    }

    let titleClient = this.props.fleetId === '-1' || !this.props.fleetData?.fleet?.entityComponent?.dniCif ? '' : this.props.fleetData?.fleet?.entityComponent?.dniCif + ' - ' + this.props.fleetData?.fleet?.entityComponent?.name

    if (titleClient.length > stringLength.TITLE) {
      titleClient = titleClient.substring(0, stringLength.TITLE) + '...'
    }

    let bar = this.props.fleetId === '-1' ? '' : ' | '
    return (
      <>
        <div id="dataClientChargeComponent">
          <div className="header-panel fleet-panel-box" onClick={() => this.collapsePanelClient()}>
            <div className="name-wrapper fleet-panel-box-title">
              <h4>{t(`${tKey}CLIENT`)} {bar} <span className='fleet-panel-subTitle'> {titleClient}</span></h4>
            </div>
            <i className={this.state.openPanelClient ? 'ico-arrow-black-down fleet-panel-box-caret' : 'ico-arrow-black-up fleet-panel-box-caret'} />
          </div>
          <Panel expanded={this.state.openPanelClient} onToggle={() => {}}>
            <Panel.Collapse>
              <Client
                t={t}
                isClientLoaded={true}
                dossier={dossier}
                combos={combos}
                entityChangeable={fleetData?.changeEntity}
                dossierType={dossierTypesConstant.createNewFleetModal}
                readOnlyFields={readOnlyFields || false}
                open={true}
                componentConfiguration={clientFleetPermissions}
                disableDeleteButton ={disableDeleteButton}
                change={change}
                updateComponentAfterDeleteAndRestart = {() => this.updateComponentAfterDeleteAndRestart()}
                formValues={formValues}
                newFleetPage={true}
                newFleetPageCreate={this.props.fleetId === '-1'}
                actions={{
                  change,
                  fetchClientByDni,
                  fetchClientByDniEntityChild,
                  fetchClientFromDocument,
                  setEntityTypeId,
                  setEntitySubTypeId,
                  setEntityId,
                  fetchEntitySubTypeCombo,
                  fetchEntityFilterSubTypeCombo,
                  setEntityChildTypeId,
                  clearEntity,
                  clearEntityChild,
                  fetchSalesClient,
                  setEntityValidationDisable,
                  setActiveSection,
                  fetchCommercialSocietyTypeCombo,
                  foreignPassportWarning: () => this.foreignPassportWarning(),
                  fetchEntityCountryTypeCombo,
                  fetchEntityStateTypeCombo,
                  fetchEntityCityTypeCombo,
                  fetchEntityTownTypeCombo,
                  fetchEntityColonyTypeCombo,
                  fetchEntityCPTypeCombo,
                  fetchEntityMaritalStatusCombo,
                  openCommonModal: openModal,
                  fetchActivityBpro,
                  resetValues,
                  validate,
                  dispatch,
                  asyncValidate: asyncValidateFunc,
                  stopAsyncValidation,
                  fetchClientDataAddress,
                  clearClientFields
                }}
              />
            </Panel.Collapse>
          </Panel>

          <ChargeFleetListComponentPage
            fleet={fleetData?.fleet}
            fleetId={fleetId}
            readOnlyFields={readOnlyFields}
            dossierSubType={fleetData?.fleet?.dossierSubType}
            tabActiveKey={tabActiveKey}
            haveChanges={haveChanges}
            actions={this.props.actions}
          />
        </div>
      </>
    )
  }
}
export default DataClientChargeComponent
